import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-c01-form-extra-prop" }
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "p-the-c01-form-extra-prop__label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createVNode(_component_InputText, {
      id: _ctx.id,
      name: _ctx.id,
      type: "text",
      modelValue: _ctx.internalValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalValue) = $event)),
      placeholder: _ctx.placeholder
    }, null, 8, ["id", "name", "modelValue", "placeholder"])
  ]))
}